// extracted by mini-css-extract-plugin
module.exports = {"iconSearches":"searchTabs_iconSearches__2vmse","linkButtonSearches":"searchTabs_linkButtonSearches__1fCPX","topCount":"searchTabs_topCount__25NFj"};